import React, { useState } from 'react';
import style from './TradePlanViewsContainer.module.css';
import ActiveTradePlanModule from '../activeTradePlanModule/ActiveTradePlanModule';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { TradePlanGlobalControls } from './tradePlanGlobalControls/TradePlanGlobalControls';
const sortMap = {
  bySymbol: 'tradePlanIdsSortedBySymbol',
  byStatus: 'tradePlanIdsSortedByStatus',
  byTemplate: 'tradePlanIdsSortedByTemplate',
  byCreationTime: 'tradePlanIdsSortedByCreateTime',
};

const TradePlanViewsContainer = observer(() => {
  const { tradePlanStore } = useWebsocketStore();
  const [sortingKeyword, setSortingKeyword] = useState('bySymbol');
  const getter = sortMap[sortingKeyword];
  const width = window.innerWidth;
  if (width > 1900)
    return (
      <div className={style.outerContainer}>
        <TradePlanGlobalControls
          sortingKeyword={sortingKeyword}
          setSortingKeyword={setSortingKeyword}
        />
        <div className={style.container}>
          <div className={style.leftColumn}>
            {tradePlanStore[getter].map((id, index) => {
              if (index % 3 === 0)
                return <ActiveTradePlanModule key={id} tradePlanId={id} />;
              else return null;
            })}
          </div>
          <div className={style.leftColumn}>
            {tradePlanStore[getter].map((id, index) => {
              if (index % 3 === 1)
                return <ActiveTradePlanModule key={id} tradePlanId={id} />;
              else return null;
            })}
          </div>
          <div className={style.leftColumn}>
            {tradePlanStore[getter].map((id, index) => {
              if (index % 3 === 2)
                return <ActiveTradePlanModule key={id} tradePlanId={id} />;
              else return null;
            })}
          </div>
        </div>
      </div>
    );
  if (width > 1200)
    return (
      <div className={style.outerContainer}>
        <TradePlanGlobalControls
          sortingKeyword={sortingKeyword}
          setSortingKeyword={setSortingKeyword}
        />
        <div className={style.container}>
          <div className={style.leftColumn}>
            {tradePlanStore[getter].map((id, index) => {
              if (index % 2 === 0)
                return <ActiveTradePlanModule key={id} tradePlanId={id} />;
              else return null;
            })}
          </div>
          <div className={style.leftColumn}>
            {tradePlanStore[getter].map((id, index) => {
              if (index % 2 !== 0)
                return <ActiveTradePlanModule key={id} tradePlanId={id} />;
              else return null;
            })}
          </div>
        </div>
      </div>
    );
  else
    return (
      <div className={style.outerContainer}>
        <TradePlanGlobalControls
          sortingKeyword={sortingKeyword}
          setSortingKeyword={setSortingKeyword}
        />
        <div className={style.container}>
          {tradePlanStore[getter].map((id) => {
            return <ActiveTradePlanModule key={id} tradePlanId={id} />;
          })}
        </div>
      </div>
    );
});

TradePlanViewsContainer.propTypes = {
  tradePlanIds: PropTypes.array,
};
export default TradePlanViewsContainer;
